import { render, staticRenderFns } from "./CuserInfo.vue?vue&type=template&id=2ec9539e&scoped=true"
import script from "./CuserInfo.vue?vue&type=script&lang=js"
export * from "./CuserInfo.vue?vue&type=script&lang=js"
import style0 from "./CuserInfo.vue?vue&type=style&index=0&id=2ec9539e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec9539e",
  null
  
)

export default component.exports